export default "__VITE_ASSET__lutHN01V__"